import './flag-button.less';

import React, {useState} from 'react';
import {Icon} from 'antd';
import classNames from 'classnames';

export const FlagButton = ({ enabled, onChange }) => {
  const theme = enabled ? 'filled' : 'outlined';
  const color = enabled ? '#f00' : '#000';

  return (
    <div className={classNames('flag-button', enabled ? 'flag-button--enabled' : 'flag-button-disabled')}>
      <Icon type="flag" theme={theme} style={{ color }} onClick={() => onChange(!enabled)} />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/flag-button.js